import { render, staticRenderFns } from "./PreviewRelacion.vue?vue&type=template&id=4bc43927&scoped=true"
import script from "./PreviewRelacion.vue?vue&type=script&lang=js"
export * from "./PreviewRelacion.vue?vue&type=script&lang=js"
import style0 from "./PreviewRelacion.vue?vue&type=style&index=0&id=4bc43927&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bc43927",
  null
  
)

export default component.exports